
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-346d8584\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./modalDsn.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalDsn.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-346d8584\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalDsn.vue.html"),
  /* scopeId */
  "data-v-346d8584",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modalComponents/modalDsn/modalDsn.vue.html
// module id = nkS3
// module chunks = 2